// The module-level `sellerInfo` constant that used to live here is gone: the
// seller identity now comes from the entity registry
// (shared/config/entity-config.ts) via sellerFor/toSellerPrintBlock, so it can
// never again be read from ambient state.

const monthSelection = [
    {
        id: 1,
        text: 'มกราคม',
    },
    {
        id: 2,
        text: 'กุมภาพันธ์',
    },
    {
        id: 3,
        text: 'มีนาคม',
    },
    {
        id: 4,
        text: 'เมษายน',
    },
    {
        id: 5,
        text: 'พฤษภาคม',
    },
    {
        id: 6,
        text: 'มิถุนายน',
    },
    {
        id: 7,
        text: 'กรกฎาคม',
    },
    {
        id: 8,
        text: 'สิงหาคม',
    },
    {
        id: 9,
        text: 'กันยายน',
    },
    {
        id: 10,
        text: 'ตุลาคม',
    },
    {
        id: 11,
        text: 'พฤศจิกายน',
    },
    {
        id: 12,
        text: 'ธันวาคม',
    },
];

export { monthSelection };
